import { CircleAlert } from "lucide-react";
import React from "react";
import Stack from "../../Stack";
import { BaseHelperMessage } from "./styled";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var HelperMessage = /*#__PURE__*/React.forwardRef(function (_ref, forwardedRef) {
  var hasError = _ref.hasError,
    id = _ref.id,
    children = _ref.children;
  return /*#__PURE__*/_jsx(BaseHelperMessage, {
    hasError: hasError,
    id: id,
    ref: forwardedRef,
    "aria-live": hasError ? "assertive" : "off",
    children: hasError ? /*#__PURE__*/_jsxs(Stack, {
      direction: "horizontal",
      spacing: "xs",
      align: "center",
      children: [hasError && /*#__PURE__*/_jsx(CircleAlert, {
        size: "0.875rem",
        color: "var(--vitality-colors-critical11)"
      }), children]
    }) : children
  });
});
HelperMessage.displayName = "HelperMessage";
export default HelperMessage;